import { __decorate } from "tslib";
import Component from "vue-class-component";
import Task from "@/services/task";
import ReactiveComponent from "@/components/ReactiveComponent";
import TemplateContent from "@/components/template/TemplateContent.vue";
let Users = class Users extends ReactiveComponent {
    constructor() {
        super(...arguments);
        this.tdClass = "users-datatable";
        this.fields = [
            { key: "year", label: "Year", sortable: true, tdClass: this.tdClass },
            { key: "week", label: "Week", sortable: true, tdClass: this.tdClass },
            { key: "actions", label: "Actions", sortable: false, tdClass: this.tdClass }
        ];
        this.filter = null;
        // historyListQuery: HistoryListQuery = {training_by_week_distinct: []}
        this.historyListQuery = { training_by_week: [] };
        this.historyListTask = Task.idle();
        this.updateStatusTask = Task.idle();
        this.deleteTask = Task.idle();
    }
    created() {
        this.subscribeQuery({
            tag: "historyList",
            options: {
                query: require("@/apollo/queries/historyList.graphql")
            },
            onTask: task => {
                this.historyListTask = task;
                if (task.isSuccessful) {
                    this.historyListQuery = task.data;
                }
            }
        });
    }
    get trainings() {
        // return this.historyListQuery.training_by_week_distinct
        return this.historyListQuery.training_by_week;
    }
};
Users = __decorate([
    Component({
        components: { TemplateContent }
    })
], Users);
export default Users;
